import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DetailedPreference from './DetailedPreference';

const DetailedPreferenceModal = ({ selectedPreference, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Communication Preference Detail for {selectedPreference.serviceOfferingId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailedPreference selectedPreference={selectedPreference} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

DetailedPreferenceModal.propTypes = {
  selectedPreference: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedPreferenceModal;
